<!--
 * @Author: mobai
 * @Date: 2022-08-10 18:02:15
 * @LastEditors: shenlin
 * @LastEditTime: 2022-10-19 16:10:43
 * @FilePath: \qym-lishui\src\gov\views\yardVoucher\whiteListApplication\applyEntrance.vue
-->
<template>
  <div class="app-container">
    <div class="header">
      <el-alert type="info" show-icon :closable="false">
        <div slot="title">
          <div class="title">发票说明</div>
          <div>
            1、根据最新服务券管理办法，中介机构每年需要二次提交发票资料并等待审核完成
          </div>
          <div>2、提交并审核通过后，当年无法继续提交</div>
          <div>
            3、每年首次提交发票资料和编辑，均有时间限制，详情请咨询管理员
          </div>
        </div>
      </el-alert>
      <div class="notes">
        <el-select v-model="dataYear" @change="getEntWhiteCouponStatus">
          <el-option
            v-for="(item, index) in dataList"
            :key="index"
            :label="item.time + '年'"
            :value="item.time"
          >
          </el-option>
        </el-select>
        <div style="margin-top: 5px">点击年份筛选，查看历史记录</div>
      </div>
    </div>
    <div class="info-box">
      <img :src="getImgSrc()" :style="getStyle()" alt="" />
      <div class="title">{{ title }}</div>
      <div class="content">{{ content }}</div>
      <div>
        <el-button
          v-if="year == dataYear"
          type="primary"
          @click="operationDetail()"
          >{{ btnTxt }}</el-button
        >
        <el-button v-if="status == 1 || status == 2" @click="check()"
          >查看详情</el-button
        >
      </div>
    </div>
    <div class="step-content">
      <div class="step-item" v-for="(item, index) in stepList" :key="index">
        <div :class="['step-item-num', item.highlight ? 'active' : '']">
          {{ item.num }}
        </div>
        <div class="step-item-desc">{{ item.desc }}</div>
        <div class="step-item-line" v-if="index !== 2"></div>
      </div>
    </div>
    <div class="remark-box" v-if="status == 2 || status == 3">
      <div class="remark-box-info">
        <div class="status">{{ statusList[status] }}</div>
        <div class="desc">备注：{{ recordItem.remark || '-' }}</div>
        <div class="desc">操作时间：{{ recordItem.operateTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getInvoiceStatus,
  getInvoiceRecordList,
  getDataYear
} from '@api/yardIntermediary/invoice'
export default {
  name: 'ApplyEntrance',
  data() {
    return {
      title: '',
      content: '',
      btnTxt: '',
      dataYear: null,
      dataList: [],
      statusInfoList: [
        {
          title: '您还未上传发票信息',
          content: '请在规定时间内补充完整资料',
          btnTxt: '立即上传',
          imgSrc: 'invoice-error'
        },
        {
          title: '提交成功',
          content: '您已成功提交兑现资料，请耐心等待管理员审核',
          btnTxt: '修改信息',
          imgSrc: 'invoice-success'
        },
        {
          title: '审核驳回',
          content: '请核对并修改信息后，再重新提交',
          btnTxt: '重新提交',
          imgSrc: 'tip-reject'
        },
        {
          title: '恭喜您审核通过',
          content: '',
          btnTxt: '查看详情',
          imgSrc: 'tip-success'
        }
      ],
      stepList: [
        {
          num: 1,
          desc: '上传兑现资料',
          highlight: false
        },
        {
          num: 2,
          desc: '等待审核',
          highlight: false
        },
        {
          num: 3,
          desc: '完成操作',
          highlight: false
        }
      ],
      statusList: {
        1: '提交审核材料',
        2: '审核驳回',
        3: '审核通过'
      },
      recordItem: {
        time: '2022-08-08 15:15',
        name: '丽企之家管理员',
        remark: '营业执照不清晰，请重新上传',
        statusName: '审核通过'
      },
      status: 0, // 0 待提交、1 待审核、2审核驳回、3 申领成功
      showAllInfo: false,
      timeMsg: null,
      timeFlag: null,
      year: null
    }
  },
  created() {
    this.getDataYear()
  },
  mounted() {
    var now = new Date()
    this.year = now.getFullYear()
  },
  methods: {
    getDataYear() {
      getDataYear().then(res => {
        const { code, data } = res.data
        if (code == '0000') {
          this.dataList = data || []
          this.dataYear = this.dataList[0].time
          this.getEntWhiteCouponStatus()
        }
      })
    },
    handleClose(data) {
      this.showAllInfo = data
    },
    getEntWhiteCouponStatus() {
      getInvoiceStatus({ dataYear: this.dataYear }).then(res => {
        const { code, data } = res.data
        if (code == '0000') {
          this.status = data.examStatus
          this.title = this.statusInfoList[this.status].title
          this.content = this.statusInfoList[this.status].content
          this.btnTxt = this.statusInfoList[this.status].btnTxt
          this.stepList[0].highlight = this.status > 0
          this.stepList[1].highlight = this.status == 1 || this.status > 2
          this.stepList[2].highlight = this.status > 2
          if (this.status == 2 || this.status == 3) {
            this.getListRecords()
          }
        }
      })
    },
    getListRecords() {
      let params = {
        dataYear: this.dataYear
      }
      getInvoiceRecordList(params).then(res => {
        const { code, data } = res.data
        if (code == '0000') {
          this.recordItem = data && data.length ? data[0] : ''
        }
      })
    },
    operationDetail() {
      this.$router.push({
        name: 'uploadDetail',
        query: { dataYear: this.dataYear, status: this.status, check: this.status == 3 }
      })
    },
    check() {
      this.$router.push({
        name: 'uploadDetail',
        query: { dataYear: this.dataYear, status: this.status, check: true }
      })
    },
    // 根据不同状态，动态获取图片
    getImgSrc() {
      return require('@/assets/' +
        this.statusInfoList[this.status].imgSrc +
        '.png')
    },
    // 根据不同状态，动态获取图片样式
    getStyle() {
      return {
        width: '70px',
        height: '70px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$color85: rgba(0, 0, 0, 0.85);
$color65: rgba(0, 0, 0, 0.65);
$color45: rgba(0, 0, 0, 0.45);

.header {
  /deep/.el-alert {
    align-items: flex-start;
  }
  /deep/ .el-alert--info.is-light {
    background: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 2px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
  /deep/.el-alert__content {
    padding-right: 40px;
  }
  /deep/.el-alert__title {
    line-height: 22px;
  }
  /deep/.el-alert__icon {
    padding-top: 4px;
    color: #91d5ff;
  }
  .title {
    color: $color85;
    font-weight: 500;
    font-size: 16px;
  }
  .notes {
    margin-top: 20px;
    .circle {
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      background: #ff8826;
      vertical-align: middle;
      margin-right: 8px;
    }
  }
  .showTitle {
    color: #1890ff;
    cursor: pointer;
  }
}
.info-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 45px;
  .title {
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    margin: 28px 0 8px;
    color: $color85;
  }
  .content {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: $color45;
  }
  /deep/.el-button {
    margin-top: 24px;
  }
}
.step-content {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  .step-item {
    display: flex;
    justify-content: center;
    align-items: center;
    &-num {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      text-align: center;
      line-height: 32px;

      font-size: 14px;
      color: rgba(0, 0, 0, 0.25);
      border: 1px solid rgba(0, 0, 0, 0.15);
      margin: 0 10px 0 0;
      &.active {
        background: #1890ff;
        color: #ffffff;
      }
    }
    &-desc {
      color: $color45;
    }
    &-line {
      width: 300px;
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      margin: 0 10px;
    }
  }
}
.remark-box {
  background: #f7f7f7;
  border-radius: 2px;
  width: 1000px;
  margin: 0 auto;
  margin-top: 15px;
  &-info {
    padding: 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: $color65;
    .status {
      font-size: 16px;
      line-height: 24px;
      color: $color85;
    }
    .desc {
      margin-top: 8px;
    }
  }
}
</style>
